import React from 'react';
import { kbbAndAtcLogoImgUrl, sellYourCarSuv } from '../../constants/config';
import { sendClick } from 'reaxl-analytics';
import Image from 'next/image';
import { imageLoader } from '../../../utils';
import { Button } from '@argo/ui-elements';
import { FlexBox } from '@argo/principles';
import { sellMyCarUrl } from '../../constants/config';

const sellYourCarText = 'Sell Your Car';
const verifiedBuyersText = 'Chat directly with verified buyers, schedule test drives, and sell online from the comfort of your home.';
const sellMyCarButtonText = 'Sell My Car';
export default function BuyerLandingSellCar() {
  const onSellMyCarClick = (event: any) => {
    sendClick('sellMyCarClick', event);
  };

  return (
    <div className="sell-your-car-section">
      <p className="sell-your-car-text">{sellYourCarText}</p>
      <FlexBox className="sell-your-car-content" flexWrap="nowrap" alignItems="center" justifyContent="center">
        <div className="sellSuv">
          <Image
            loader={imageLoader}
            src={sellYourCarSuv}
            alt="Sell Your Car SUV"
            width={229}
            height={214}
          />
        </div>
        <div className="sell-cta">
          <p>{verifiedBuyersText}</p>
          <Button
            width="103%"
            bsStyle="primary"
            text={sellMyCarButtonText}
            href={sellMyCarUrl}
            onClick={(event: any) => onSellMyCarClick(event)}
            rel="nofollow"
            target="_blank"
          />
          <div>
            <Image
              loader={imageLoader}
              src={kbbAndAtcLogoImgUrl}
              alt="Sell My Car"
              width={298}
              height={56}
              sizes="298px"
            />
          </div>
        </div>
        <div className="spacer" />
      </FlexBox>
    </div>
  );
}
